// feature.js
import React from 'react';
import './Feature.css';

function Feature() {
    return (
        <section className="features">
            <h2>Key Features :</h2>
            <div className="container">
                <div className="ag-format-container">
                    <div className="ag-courses_box">
                        <div className="ag-courses_item">
                            <a href="#" className="ag-courses-item_link">
                                <div className="ag-courses-item_bg"></div>
                                <div className="ag-courses-item_title">
                                    Real-time Monitoring
                                </div>
                                <div className="ag-courses-item_date-box">
                                    The system utilizes the YOLO (You Only Look Once) model to detect weapons in real-time from a video stream, ensuring immediate identification of threats for security applications.
                                </div>
                            </a>
                        </div>

                        <div className="ag-courses_item">
                            <a href="#" className="ag-courses-item_link">
                                <div className="ag-courses-item_bg"></div>
                                <div className="ag-courses-item_title">
                                    Strategy Mapping
                                </div>
                                <div className="ag-courses-item_date-box">
                                    After detecting a weapon, the system maps it to a predefined strategy (such as response actions), improving decision-making for security personnel.
                                </div>
                            </a>
                        </div>

                        <div className="ag-courses_item">
                            <a href="#" className="ag-courses-item_link">
                                <div className="ag-courses-item_bg"></div>
                                <div className="ag-courses-item_title">
                                    Detection History Management
                                </div>
                                <div className="ag-courses-item_date-box">
                                    The system keeps a history of the last 10 detections, helping to track and analyze security events for potential trends and patterns.
                                </div>
                            </a>
                        </div>

                        <div className="ag-courses_item">
                            <a href="#" className="ag-courses-item_link">
                                <div className="ag-courses-item_bg"></div>
                                <div className="ag-courses-item_title">
                                    Dynamic Frontend Update
                                </div>
                                <div className="ag-courses-item_date-box">
                                    The frontend automatically updates with the latest detection data, providing real-time feedback to users without the need for page refresh.
                                </div>
                            </a>
                        </div>

                        <div className="ag-courses_item">
                            <a href="#" className="ag-courses-item_link">
                                <div className="ag-courses-item_bg"></div>
                                <div className="ag-courses-item_title">
                                    Confidence Threshold for Detection
                                </div>
                                <div className="ag-courses-item_date-box">
                                    Detections are filtered based on a confidence threshold, ensuring that only reliable and highly probable threats are displayed.
                                </div>
                            </a>
                        </div>

                        <div className="ag-courses_item">
                            <a href="#" className="ag-courses-item_link">
                                <div className="ag-courses-item_bg"></div>
                                <div className="ag-courses-item_title">
                                    Real-Time Data Fetching and Display
                                </div>
                                <div className="ag-courses-item_date-box">
                                    The system continuously fetches detection data from the backend, ensuring that users receive the most up-to-date information in real time.
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Feature;
